import { gql } from '@apollo/client';

const GET_GUESS_THE_ORDER_ACTIVITY = gql`
  query guessTheOrder($where: ActivityWhereInput!) {
    guessTheOrder(where: $where) {
      id
      title
      book {
        title
        bookCode
        characters {
          id
          character
          characterCase
          characterType
        }
      }
      activityType {
        id
        name
      }
      instructions {
        introduction {
          id
          src
          vtt
        }
        summary {
          id
          src
          vtt
        }
      }
      storyElements {
        instructions {
          id
          src
          vtt
        }
        affirmation {
          id
          src
          vtt
          description
        }
        tile {
          id
          src
          description
          storyOrder
        }
        scene {
          id
          src
          description
        }
      }
    }
  }
`;

export default GET_GUESS_THE_ORDER_ACTIVITY;
